/**
 * HP bar levels (slice 8c): green, yellow or red by the share of max HP left, at the thresholds in
 * balance.json `hp.bar`. The field's bars, the matchup board's rows and the Bench strip all read
 * their color from here, so the CSS never decides a threshold.
 */
import { balance } from '@tdmons/sim';

export type HpLevel = 'high' | 'mid' | 'low';

export function hpLevel(hp: number, max: number): HpLevel {
  const r = max > 0 ? hp / max : 0;
  if (r >= balance.hp.bar.mid) return 'high';
  if (r >= balance.hp.bar.low) return 'mid';
  return 'low';
}

/** The share of max HP left, 0..1. */
export const hpRatio = (hp: number, max: number): number =>
  max > 0 ? Math.min(1, Math.max(0, hp / max)) : 0;

/** An HP bar (`.bar > i`), sized and colored for hp of max. */
export function hpBar(hp: number, max: number): HTMLElement {
  const bar = document.createElement('span');
  bar.className = `bar hp-${hpLevel(hp, max)}`;
  bar.setAttribute('role', 'img');
  bar.setAttribute('aria-label', `HP ${Math.round(hp)} of ${max}`);
  const fill = document.createElement('i');
  fill.style.width = `${(hpRatio(hp, max) * 100).toFixed(1)}%`;
  bar.append(fill);
  return bar;
}
